import { statusCrmGraphMapper } from '@utils/statusGraphHelper'
import { ICrmStatGraph } from '@dto/crm/crmInfo.dto'

export const graphCrmConfig = (val: ICrmStatGraph[]) => ({
  smooth: true,
  autoFit: true,
  data: statusCrmGraphMapper(val),
  // width: 700,
  height: 300,
  appendPadding: 10,
  xField: 'day',
  yField: 'value',
  seriesField: 'category',
  xAxis: {
    label: {
      formatter: (v) => `${v}`.replace(/\d{1,3}(?=(\d{3})+$)/g, (s) => `${s},`),
      style: {
        fill: 'white',
      },
    },
    grid: {
      line: {
        style: {
          stroke: '#ddd',
          lineDash: [4, 2],
        },
      },
    },
  },
  yAxis: {
    label: {
      style: {
        fill: 'white',
      },
    },
    grid: {
      line: {
        style: {
          stroke: '#ddd',
          lineDash: [4, 2],
        },
      },
    },
  },
  color: ['#02ff17', '#f38877', '#fdcc74', '#a0cff8', '#f85ff5', '#8c70fa', '#D62A0D', '#69fab1'],
  legend: {
    position: 'left' as const,
    itemName: {
      style: {
        fill: 'white',
      },
    },
  },
  interactions: [
    {
      type: 'marker-active',
    },
  ],
  meta: {
    day: {
      range: [0, 1],
    },
  },
})
